import {FC, useState} from "react";

import ReactJsonView from "@microlink/react-json-view";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./dialog";

export const JSON_VIEWER_THEME = {
  base00: "#171717",
  base01: "red",
  base02: "#171717",
  base03: "green",
  base04: "purple",
  base05: "#171717",
  base06: "blue",
  base07: "#78cdbd",
  base08: "#78cdbd",
  base09: "#b68ef1",
  base0A: "#ff5874",
  base0B: "red",
  base0C: "#78cdbd",
  base0D: "#78cdbd",
  base0E: "#78cdbd",
  base0F: "#c789d6",
};

interface JsonViewDialogProps {
  data: object;
  trigger: React.ReactNode;
}

const JsonViewDialog: FC<JsonViewDialogProps> = ({data, trigger}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        className="flex flex-col w-[80vw] max-w-[1200px] h-[80vh]"
        onOpenAutoFocus={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Expanded JSON</DialogTitle>
        </DialogHeader>
        <div
          className="flex-1 overflow-auto"
          style={{backgroundColor: "#171717"}}
        >
          <ReactJsonView
            name={null}
            src={data}
            enableClipboard={false}
            displayObjectSize={false}
            collapsed={false}
            displayDataTypes={false}
            theme={JSON_VIEWER_THEME}
            style={{
              backgroundColor: "transparent",
              padding: "1rem",
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default JsonViewDialog;
